import React from "react";

const PollsCard = ({ getPolls }) => {
  return (
    <>
      {getPolls?.map((item, idx) => {
        const options = [
          item?.option1,
          item?.option2,
          item?.option3,
          item?.option4,
        ].filter(Boolean);

        return (
          <div
            key={idx}
            className="relative bg-white border border-gray-200 rounded-[8px] p-6
             shadow-[5px_5px_4px_rgba(0,0,0,0.15)]
             hover:shadow-[5px_6px_5px_rgba(249,115,22,0.45)]"
          >
            {/* Soft Gradient Hover Effect */}
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-orange-50 to-transparent opacity-0 hover:opacity-100 transition duration-500 pointer-events-none" />

            {/* Question */}
            <h3 className="text-lg font-[600] text-gray-800 mb-6 leading-snug">
              {item?.question}
            </h3>

            {/* Options */}
            <div className="space-y-3">
              {options.map((option, i) => {
                return (
                  <div  key={i}>
                    <p className="text-[rgb(33_37_41_/_75%)]">{option}</p>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default PollsCard;
